module.exports = __webpack_public_path__ + "cryengine.ba0423.svg";